import React, { useEffect, useState } from 'react';
import { collection, query, orderBy, onSnapshot, updateDoc, doc } from 'firebase/firestore';
import { db } from '../firebase';
import AdminSidebar from '../components/AdminSidebar';
import './AdminMessages.css';

const AdminMessages = () => {
  const [messages, setMessages] = useState([]);

  useEffect(() => {
    const q = query(collection(db, 'driver_messages'), orderBy('timestamp', 'desc'));
    const unsubscribe = onSnapshot(q, (snapshot) => {
      const msgs = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      console.log("📥 الرسائل التي تم تحميلها:", msgs);
      setMessages(msgs);
    });
    return () => unsubscribe();
  }, []);

  const markAsRead = async (id) => {
    await updateDoc(doc(db, 'driver_messages', id), { status: 'read' });
  };

  return (
    <div className="admin-page">
      <AdminSidebar />
      <div className="content">
        <h2>📨 رسائل الطوارئ من السائقين</h2>
        {messages.length === 0 ? (
          <p>لا توجد رسائل حالياً.</p>
        ) : (
          messages.map((msg) => (
            <div
              key={msg.id}
              className={`message-card ${msg.status === 'new' ? 'new' : 'read'}`}
              onClick={() => markAsRead(msg.id)}
            >
              <p><strong>🚗 السائق:</strong> {msg.driverName}</p>
              <p><strong>📝 الرسالة:</strong> {msg.message}</p>
              <p><strong>⏰ الوقت:</strong> {msg.timestamp?.toDate
                ? new Date(msg.timestamp.toDate()).toLocaleString()
                : 'غير متوفر'}
              </p>
              <p><strong>📌 الحالة:</strong> {msg.status === 'new' ? 'جديدة' : 'مقروءة'}</p>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default AdminMessages;
